// extracted by css-extract-rspack-plugin
export default {"SetupSection":"VFA2w","StatusBadge":"mHpfG"};